import React from "react";
import { SECTION_OPTIONS } from "../constants";

const AddSectionSidebar = ({
  sectionForm,
  handleSectionFormChange,
  handleCreateSection,
  sectionsCount,
}) => {
  return (
    <div className="mb-4 flex flex-wrap items-end gap-4 rounded-xl">
      <div className="flex-1">
        <label className="mb-1 block text-[10px] font-bold uppercase tracking-wider text-slate-400">
          Section Name
        </label>
        <input
          name="name"
          value={sectionForm.name}
          onChange={handleSectionFormChange}
          placeholder="e.g. North Bay"
          className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-slate-400"
        />
      </div>
      <div className="flex-1">
        <label className="mb-1 block text-[10px] font-bold uppercase tracking-wider text-slate-400">
          Section Type
        </label>
        <select
          name="type"
          value={sectionForm.type}
          onChange={handleSectionFormChange}
          className="w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-400"
        >
          {SECTION_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <button
          onClick={handleCreateSection}
          className="rounded-xl bg-[#1e1e1e] px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-black"
        >
          Add section
        </button>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <div className="h-2 w-2 rounded-full bg-emerald-400" />
        <span className="text-sm font-medium text-slate-500">
          {sectionsCount} sections · Auto-placed
        </span>
      </div>
    </div>
  );
};

export default AddSectionSidebar;
